module.exports = __webpack_public_path__ + "static/img/KPLF.e76f40b.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KPLF.png
// module id = Veh8
// module chunks = 1